<template>
  <el-dialog :visible.sync="visible" :title="title" width="450px">
    <el-form ref="dataForm" :model="data" :rules="rules" label-position="right" label-width="80px" size="mini">

      <el-row>
        <el-col :span="12">
          <el-form-item prop="log_id" label="逻辑编号">
            <el-input v-model="data.log_id" :disabled="!allPropEditable"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="phy_id" label="物理编号">
            <el-input v-model="data.phy_id" :disabled="!allPropEditable"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item prop="province" label="设备地址">
            <el-input v-model="data.province" placeholder="省"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="6">
          <el-form-item prop="city" label-width="0">
            <el-input v-model="data.city" placeholder="市"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="6">
          <el-form-item prop="county" label-width="0">
            <el-input v-model="data.county" placeholder="县"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item prop="district">
            <el-input v-model="data.district" placeholder="区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="6">
          <el-form-item prop="street" label-width="0">
            <el-input v-model="data.street" placeholder="街道"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="6">
          <el-form-item prop="address" label-width="0">
            <el-input v-model="data.address" placeholder="详细"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="13">
          <el-form-item prop="lon" label="经纬坐标">
            <el-input v-model="data.lon" placeholder="经度"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="10">
          <el-form-item prop="lat" label-width="0">
            <el-input v-model="data.lat" placeholder="纬度"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="13">
          <el-form-item prop="dtype_source" label="设备类型">
            <el-select v-model="data.dtype_source">
              <el-option value="室外无源"></el-option>
              <el-option value="室内有源"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="10">
          <el-form-item prop="dtype_move" label-width="0">
            <el-select v-model="data.dtype_move" style="width:100%;">
              <el-option value="移动"></el-option>
              <el-option value="固定"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="13">
          <el-form-item prop="dtype_os" label="操作系统">
            <el-select v-model="data.dtype_os">
              <el-option value="Android"></el-option>
              <el-option value="iOS"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="text-align:center;">-</el-col>
        <el-col :span="10">
          <el-form-item prop="os_version" label-width="0">
            <el-input v-model.trim="data.os_version" placeholder="版本号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item prop="dtype_net" label="网络类型" v-if="allPropEditable">
            <el-select v-model="data.dtype_net" style="width:100%;">
              <el-option value="4G"></el-option>
              <el-option value="WiFi"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="heartbeat" label="心跳间隔" v-if="allPropEditable">
            <el-input v-model="data.heartbeat"><template slot="append">分</template></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button style="float:right;" type="primary" @click="save">保存</el-button>
        <el-button style="float:right;margin-right:5px;" @click="visible = false">取 消</el-button>
      </el-form-item>

    </el-form>
  </el-dialog>
</template>

<script>
  import VueEvent from "@/models/VueEvent.js";
  export default {
    beforeDestroy() {
      VueEvent.$off("editDevice");
      VueEvent.$off("addDevice");
    },
    mounted() {
      VueEvent.$on("editDevice", params => {
        this.$getJSON("/terminal/s_deviceDetail", {
          device_lgid: params.lgid
        }).then(res => {
          this.data = JSON.parse(JSON.stringify(this.data_ini));
          for (let key in this.data)
            if (res.data[0][key]) this.data[key] = res.data[0][key];
          this.type = "edit";
          this.title = "编辑设备";
          this.allPropEditable = false; //设备号、操作系统等信息禁止用户编辑修改
          this.visible = true;
        });
      });
      VueEvent.$on("addDevice", () => {
        this.type = "add";
        this.data = JSON.parse(JSON.stringify(this.data_ini));
        this.allPropEditable = true;
        this.visible = true;
      });
    },
    data() {
      return {
        type: "",
        visible: false,
        title: "添加设备",
        allPropEditable: true,
        data: {},
        data_ini: {
          log_id: "",
          phy_id: "",
          province: "",
          city: "",
          county: "",
          district: "",
          street: "",
          address: "",
          lon: "",
          lat: "",
          dtype_source: "室外无源",
          dtype_move: "固定",
          dtype_net: "4G",
          dtype_os: "Android",
          os_version: "",
          heartbeat: ""
        },
        rules: {
          log_id: [{
            required: true,
            message: "请输入逻辑编号",
            trigger: "blur"
          }],
          phy_id: [{
            required: true,
            message: "请输入物理编号",
            trigger: "blur"
          }],
          lon: [{
              required: true,
              message: "请输入经度",
              trigger: "blur"
            },
            {
              validator: function (rule, value, callback) {
                if (value) {
                  if (!/^[-]?\d+(\.\d+)?$/.test(value)) return callback(new Error("只能为数值"));
                  else if (Math.abs(Number(value)) > 180) return callback(new Error("经度范围为-180到180度"));
                  else callback();
                } else {
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
          lat: [{
              required: true,
              message: "请输入纬度",
              trigger: "blur"
            },
            {
              validator: function (rule, value, callback) {
                if (value) {
                  if (!/^[-]?\d+(\.\d+)?$/.test(value)) return callback(new Error("只能为数值"));
                  else if (Math.abs(Number(value)) > 90) return callback(new Error("经度范围为-90到90度"));
                  else callback();
                } else {
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
          os_version: [{
            required: true,
            message: "请输入版本号",
            trigger: "blur"
          }],
          heartbeat: [{
            required: true,
            message: "请输入心跳间隔",
            trigger: "blur"
          }, {
            validator: function (rule, value, callback) {
              if (value) {
                if (!/^[1-9]\d*$/.test(value)) return callback(new Error("只能为正整数"));
                else callback();
              } else {
                callback();
              }
            },
            trigger: "blur"
          }]
        }
      };
    },
    methods: {
      save() {
        this.$refs["dataForm"].validate(valid => {
          if (valid) {
            this.$confirm('是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if (this.type == "edit")
                this.$getJSON("/terminal/u_device", this.data).then(res => {
                  if (res.success) this.$message.success("修改成功");
                  else this.$message.error("修改失败");
                });
              else if (this.type == "add")
                this.$getJSON("/terminal/i_device", this.data).then(res => {
                  if (res.success) this.$message.success("添加成功");
                  else this.$message.error("添加失败");
                });
              this.visible = false;
            }).catch(() => {});
          }
        });
      }
    }
  };

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Form/DeviceEdit.vue